function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import set from 'lodash/set';
import { getColorPrimarySelector } from '@signal/theme/selectors';
import StackedBarChart, { stackedBarChartSeriesPropType } from './index';
export function StackedBarChartSkeleton(_ref) {
  var series = _ref.series,
      props = _objectWithoutProperties(_ref, ["series"]);

  var skeletonSeries = series.map(function (row, i) {
    return set(row, 'label', "skeleton_".concat(i));
  });
  return /*#__PURE__*/React.createElement(StackedBarChart, Object.assign({
    series: skeletonSeries,
    getId: function getId(s) {
      return s.label;
    }
  }, props));
}
StackedBarChartSkeleton.propTypes = {
  series: stackedBarChartSeriesPropType
};
StackedBarChartSkeleton.defaultProps = {
  series: [{
    value: 50,
    fill: getColorPrimarySelector()
  }, {
    value: 50,
    fill: getColorPrimarySelector('dark')
  }]
};
export default StackedBarChartSkeleton;